<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">CONTENTS</p>
<p class="noindent"><a href="#/ack">Acknowledgements</a></p>
<p class="noindent"><a href="#/intro">Introduction</a></p>
<p class="toc1"><a href="#/part1"><b>P<span class="small">ART</span> 1. U<span class="small">TAH</span></b></a></p>
<p class="toc"><a href="#/chapter1">“Top of the Mountains”</a></p>
<p class="toc1"><span href="#/part2" title="Link target outside of Sample"><b>P<span class="small">ART</span> 2. M<span class="small">ORMONS</span></b></span></p>
<p class="toc"><span href="#/chapter2" title="Link target outside of Sample">The Roots of Mormonism</span></p>
<p class="toc"><span href="#/chapter3" title="Link target outside of Sample">Old Scripture Revealed Anew</span></p>
<p class="toc"><span href="#/chapter4" title="Link target outside of Sample">Brigham Young and Succession</span></p>
<p class="toc1"><span href="#/part3" title="Link target outside of Sample"><b>P<span class="small">ART</span> 3. M<span class="small">ONUMENTS</span></b></span></p>
<p class="toc"><span href="#/chapter5" title="Link target outside of Sample">“This Is the Place”</span></p>
<p class="toc"><span href="#/chapter6" title="Link target outside of Sample">Temple Square and Nearby Monuments</span></p>
<p class="toc"><span href="#/chapter7" title="Link target outside of Sample">A Historic Look at Temples</span></p>
<p class="toc"><span href="#/chapter8" title="Link target outside of Sample">Temples as Spiritual Monuments</span></p>
<p class="toc"><span href="#/chapter9" title="Link target outside of Sample">Temple Topper: Angel Moroni</span></p>
<p class="toc"><span href="#/chapter10" title="Link target outside of Sample">Where Prophets and Paupers Rest</span></p>
<p class="toc"><span href="#/chapter11" title="Link target outside of Sample">Pioneer Memorial Park</span></p>
<p class="toc"><span href="#/chapter12" title="Link target outside of Sample">Of Faith and a Fort</span></p>
<p class="toc"><span href="#/chapter13" title="Link target outside of Sample">Tabernacles and Other Historic Buildings</span></p>
<p class="toc"><span href="#/chapter14" title="Link target outside of Sample">All Is Well with Church Welfare</span></p>
<p class="toc"><span href="#/chapter15" title="Link target outside of Sample">News of the Day, Yesterday and Today</span></p>
<p class="toc"><span href="#/chapter16" title="Link target outside of Sample">In the Land of Tragedy</span></p>
<p class="toc"><span href="#/chapter17" title="Link target outside of Sample">History on Display</span></p>
<p class="toc"><span href="#/chapter18" title="Link target outside of Sample">Researching and Preserving the Past</span></p>
<p class="noindent1"><span href="#/appen" title="Link target outside of Sample">Appendix</span></p>
<p class="noindent"><span href="#/notes" title="Link target outside of Sample">Notes</span></p>
<p class="noindent"><span href="#/bib" title="Link target outside of Sample">Bibliography</span></p>
<p class="noindent"><span href="#/author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?edc60eec